import axios from "axios";

const state = () => ({
  users: [],
  permissions: [],
  user_permissions: [],
  error: "",
  message: "",
  loading: false,
  updating: false,
  loading_permissions: false,
  loading_create: false,
});

const mutations = {
  SET_USERS(state, users) {
    state.users = users;
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions;
  },
  SET_USER_PERMISSIONS(state, permissions) {
    state.user_permissions = permissions;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_MESSAGE(state, message) {
    state.message = message;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_UPDATING(state, updating) {
    state.updating = updating;
  },
  SET_LOADING_PERMISSIONS(state, loading) {
    state.loading_permissions = loading;
  },
  SET_LOADING_CREATE(state, loading) {
    state.loading_create = loading;
  },
};

const getters = {
  getUsers: (state) => {
    return state.users;
  },
  getPermissions: (state) => {
    return state.permissions;
  },
  getUserPermissions: (state) => {
    return state.user_permissions;
  },
  getError: (state) => {
    return state.error;
  },
  getMessage: (state) => {
    return state.message;
  },
  isLoading: (state) => {
    return state.loading;
  },
  isUpdating: (state) => {
    return state.updating;
  },
  isLoadingCreateUser: (state) => {
    return state.loading_create;
  },
};

const actions = {
  async fetchUsers({ commit }) {
    commit("SET_LOADING", true);
    const url = process.env.VUE_APP_API_URL + "/tm/users";
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };
    try {
      const response = await axios.get(url, config);
      commit("SET_USERS", response.data.data);
      commit("SET_ERROR", "");
    } catch (error) {
      commit(
        "SET_ERROR",
        error.response?.data?.message || "Failed to fetch users."
      );
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async fetchPermissions({ commit }) {
    commit("SET_LOADING_PERMISSIONS", true);
    const url = process.env.VUE_APP_API_URL + "/tm/permissions";
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };
    try {
      const response = await axios.get(url, config);
      commit("SET_PERMISSIONS", response.data);
      commit("SET_ERROR", "");
    } catch (error) {
      commit(
        "SET_ERROR",
        error.response?.data?.message || "Failed to fetch TM permissions."
      );
    } finally {
      commit("SET_LOADING_PERMISSIONS", false);
    }
  },

  async fetchUserPermissions({ commit }, userId) {
    const url = process.env.VUE_APP_API_URL + `/tm/users/${userId}/permissions`;
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };
    try {
      const response = await axios.get(url, config);
      commit("SET_USER_PERMISSIONS", response.data);
      commit("SET_ERROR", "");
    } catch (error) {
      commit(
        "SET_ERROR",
        error.response?.data?.message || "Failed to fetch user permissions."
      );
    }
  },

  async updateUser({ commit }, { userId, payload }) {
    commit("SET_UPDATING", true);
    const url = `${process.env.VUE_APP_API_URL}/tm/users/${userId}`;
    const headers = {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    };

    try {
      await axios.patch(url, payload, { headers });
      commit("SET_MESSAGE", "User updated successfully.");
      commit("SET_ERROR", null);
    } catch (error) {
      commit("SET_ERROR", error.response?.data?.msg || "User update failed.");
    } finally {
      commit("SET_UPDATING", false);
      setTimeout(() => {
        commit("SET_MESSAGE", null);
      }, 1000);
    }
  },

  async saveUser({ commit }, payload) {
    commit("SET_LOADING_CREATE", true);
    const url = process.env.VUE_APP_API_URL + "/tm/users";
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };

    try {
      await axios.post(url, payload, config);
      commit("SET_MESSAGE", "User created successfully.");
      commit("SET_ERROR", null);
    } catch (error) {
      commit(
        "SET_ERROR",
        error.response?.data?.msg || "Failed to create a user."
      );
    } finally {
      commit("SET_LOADING_CREATE", false);
      setTimeout(() => {
        commit("SET_MESSAGE", null);
      }, 1000);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
